
import uirouter from 'angular-ui-router';
import 'angular-sanitize';
import ngToast from 'ng-toast';
import session from './session';
import loader from './loader';
import storage from './storage';

const ALERT_TYPES = {
	0: 'danger',
	1: 'warning',
	2: 'success',
	3: 'info'
};





/*
 * Service
 */
class Api {
	constructor (Session, Storage, $state, $timeout, $http, ngToast, Loader) {
		this.Session = Session;
		this.Storage = Storage;
		this.$state = $state;
		this.$timeout = $timeout;
		this.$http = $http;
		this.ngToast = ngToast;
		this.Loader = Loader;
	}

	get    (query) { return apiCall.call(this, 'get',    query); }
	post   (query) { return apiCall.call(this, 'post',   query); }
	put    (query) { return apiCall.call(this, 'put',    query); }
	delete (query) { return apiCall.call(this, 'delete', query); }
}

Api.$inject = ['Session', 'Storage', '$state', '$timeout', '$http', 'ngToast', 'Loader'];

export default angular.module('service.api', [uirouter, session, storage, 'ngToast', loader])
	.service('Api', Api)
	.name;





/*
 * Make API call
 */
function apiCall (method, { url, query, headers, body }) {
	this.Loader.open();
	var prefix = '/api/';
	if (!!this.Session.get('worker')) {
		prefix += 'ar/';
	}
	return this.$http({
		method: method || 'get',
		url: prefix+url,
		params: query,
		data: body,
		headers: generateHeaders.call(this, headers, body),
	})
	.catch(catchApiErrors.bind(this))
	.then(processEnvelope.bind(this))
	.then(processTarget.bind(this))
	.then(processMessage.bind(this))
	.then(processResponse.bind(this))
	.then(closeLoaderOnSuccess.bind(this))
	.catch(closeLoaderOnError.bind(this))
	;
}





/*
 * Request builder
 */
function generateHeaders (headers, body) {
	var user = this.Session.get('user');
	var brand = this.Session.get('brand');
	var result = {
		...(headers || {}),
		'Accept':       'application/json',
		'x-api-key':    '778bc95339972b432f1cb06c9f6c79127a4d6119bb594bab70d1def7799d9aec0c317251738484c51cf11a70d747c9ac994e034733a7147715337c638a4696d919216e099403144a2fe7f32b1980928f5ff919328bd5e99b2266239d62de26b0dd7b8b9009b5f02ba3f1e728e8a2dda0a9267d0155a9ab0c48eb918fedd947f83f8326debaab25235ce2e22c2c35e131c31e82f9e4944cedb29f4115544add1ec3811d91fe50ec1f401635948b2c05875cb84c0313ebd009ca06eaaee2951b60',
		brand:          brand,
		current:        '#none',
		target:         '#none'
	};

	if (body instanceof FormData) {
		result['Content-Type'] = undefined;
	} else {
		result['Content-Type'] = 'application/json';
	}

	if (user && user.token) {
		result.token = user.token;
	}

	return result;
}





/*
 * Process response
 */
function catchApiErrors (response) {
	if (response && response.data && response.data.message) {
		return response;
	}
	throw response;
}
function processEnvelope (response) {
	return response.data;
}

function processTarget (response) {
	if (response.target && response.target === 'loginPage') {
		this.$timeout(_ => {
			const sso = this.Storage.get('sso');
			if (sso && sso.group) {
				this.$state.go('ssoLoginPage', { group: sso.group });
			} else {
				this.$state.go('loginPage');
			}
		});
	}
	return response;
}

function processMessage (response) {
	if (response && response.message) {
		let alertType = ALERT_TYPES[response.message.type];

		if (alertType) {
			this.ngToast.create({
				className: alertType,
				content: response.message.text
			});
		}

		if (response.message.type === 0 || response.message.type === 1) {
			throw response.message.text;
		}
	}
	return response;
}

function processResponse (response) {
	return response.data;
}

function closeLoaderOnSuccess (response) {
	this.Loader.close();
	return response;
}

function closeLoaderOnError (err) {
	this.Loader.close();
	throw err;
}




// WEBPACK FOOTER //
// ./src/service/api.js